import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* loyaltyActivitySearch(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.POST,
        APIS.LOYALTY.ACTIVITY_SEARCH,
        action.payload,
        true
    );
}